module.exports = __webpack_public_path__ + "static/media/Hudson-soffa-detalj-miljö-2021.bbbfa677.jpg";